import { ProductVariantAvailabilityStatus, VariantAttribute } from "@swo/shared";
import { PDPInternalState, PDPSwarovskiProductVariantFrontend } from "../state/types";
import { EnrichedSwarovskiProductVariantFrontend, ProductDetailPageDataShared } from "@swo/storefront";
import { nonEmptyArray } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import { NonEmptyArray } from "fp-ts/NonEmptyArray";
import { getProductAvailability } from "../../state/get-product-availability";
import { attributeEq } from "../state/attributes";

export type PDPComputedState = {
  matches: Array<PDPSwarovskiProductVariantFrontend>;
  multiselects:
    | NonEmptyArray<{
        headline: string;
        name: string;
        attributes: NonEmptyArray<VariantAttribute>;
        disabled: boolean;
      }>
    | undefined;
  availability: ProductVariantAvailabilityStatus | null;
};

export function getPdpComputedState(
  pdpState: PDPInternalState,
  availabilityInfo: ProductDetailPageDataShared["availability"],
): PDPComputedState {
  const matches = calculateVariantsMatchingFilterSet(pdpState.selectedProduct.variants, pdpState.attributesSelection);

  const productAvailabilityPerVariant = getProductAvailability(availabilityInfo);

  const availability = productAvailabilityPerVariant ? productAvailabilityPerVariant(pdpState.selectedVariant.sku) : null;

  const multiselects = pdpState.multiselectsForProduct
    ? pipe(
        pdpState.multiselectsForProduct,
        nonEmptyArray.mapWithIndex((idx, multiselect) => {
          return {
            ...multiselect,
            disabled: idx > pdpState.attributesSelection.length,
          };
        }),
      )
    : undefined;

  return {
    matches,
    multiselects,
    availability,
  };
}

export function calculateVariantsMatchingFilterSet(
  variants: NonEmptyArray<PDPSwarovskiProductVariantFrontend>,
  filterSet: Array<VariantAttribute>,
): Array<PDPSwarovskiProductVariantFrontend> {
  return variants.filter(variant => {
    return filterSet.every(filter => variant.attributes.unique?.find(attr => attributeEq.equals(attr, filter)));
  });
}

export type PDPMultiselects = Array<{
  headline: string;
  attributes: NonEmptyArray<VariantAttribute>;
  disabled: boolean;
}>;

export type Multiselect = PDPMultiselects[0];
